<template>
    <div class="survey-actions col-md-12 mb-3">
        <div class="row" v-show="false">
            <div class="header">
                <div class="mb-4 header-case">
                    Guestflip's Dynamic Surveys Suggestions
                </div>
            </div>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-3">
                        {{completedSuggestions}} / {{suggestions.length}} steps completed
                    </div>
                    <div class="col-md-9">
                        <div class="progress">
                            <div class="progress-bar bg-success progress-bar-striped progress-bar-animated" role="progressbar" v-bind:style="{width: completedPercentage + '%'}" v-bind:aria-valuenow="completedPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                </div>
            </div>
            <ul class="col-md-12 mt-4">
                <li v-for="(suggestion, idx) in suggestions">
                    <i class="fas fa-check-circle fa-2x ml-3 mr-3 pull-left" v-bind:class="{'inactive': !suggestion.hasBeenFilled, 'text-success': suggestion.hasBeenFilled }"></i>
                    <div class="pull-left title">{{suggestion.title}}</div>
                    <button
                        v-if="!suggestion.hasBeenFilled || suggestion.repeatable"
                        v-on:click="activateSuggestion(suggestion.slug)"
                        v-bind:disabled="suggestions[idx - 1] && !suggestions[idx - 1].hasBeenFilled"
                        v-bind:class="{'btn-primary': !suggestion.hasBeenFilled, 'btn-default': suggestion.hasBeenFilled, 'cursor-pointer': !suggestion.hasBeenFilled}"
                        class="btn pull-right mr-3">{{suggestion.action}}</button>
                </li>
            </ul>
        </div>
        <div class="modal" id="modal_fill_hotel_address" tabindex="-1" role="dialog" ref="modal_fill_hotel_address">
            <div class="modal-dialog gf">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Let's make your survey emails more powerful
                        </h5>
                    </div>

                    <div class="modal-body">
                        <span>By filling your hotel's info in the surveys settings tab, we will be able to inject this information in the emails that are sent to your hotel's guests, so we can <strong>increase the rate of the emails that are delivered directly in your guest's inbox</strong> as well as making the email more trustworthy, <strong>increasing your surveys CTR and fill rate</strong>.</span>
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{__('Maybe later')}}</button>
                        <button v-on:click="redirectToSettings()" type="button" class="btn btn-primary">
                            <span>{{__('Lets do this')}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SurveysService from '../../services/surveys-service'
    export default {
        async mounted() {
            const response = await SurveysService.suggestions.index()
            this.suggestions = response.data
        },
        computed: {
            completedSuggestions: function () {
                return this.suggestions.filter(x => x.hasBeenFilled).length
            },
            completedPercentage: function() {
                if (!this.suggestions) return 1
                return this.suggestions.filter(x => x.hasBeenFilled).length / this.suggestions.length * 100 || 1
            },
            redirectToSettings: function() {
                $(this.$refs.modal_fill_hotel_address).modal('hide')
                $('a.nav-link[href="/surveys/#settings"]').tab('show');
            }
        },
        methods: {
            async activateSuggestion(suggestion) {
                switch(suggestion) {
                    case 'create_first_survey':
                        window.location.href = '/surveys/new'
                        break
                    case 'send_first_survey_email':
                        $('a.nav-link[href="/surveys/#surveys"]').tab('show');
                        break
                    case 'learn_how_stats_work':
                        break
                    case 'create_your_first_survey_archive':
                        $('a.nav-link[href="/surveys/#archives"]').tab('show');
                        break
                    case 'fill_your_hotels_address':
                        $(this.$refs.modal_fill_hotel_address).modal('toggle')
                        break
                }
            },
            expand() {
                this.expanded = !this.expanded
            }
        },
        data() {
            return {
                expanded: false,
                suggestions: []
            }
        }
    };
</script>
